'use client'

import { useEffect, useState } from 'react'
import { ModalDesktop, ModalMobile } from '@acko-tech/building-blocks.ui.modal'
import styles from './businessModal.module.scss'
import { LOADER_GIF } from './constants'

const BusinessModals = ({ isModalOpen, setIsModalOpen, content }) => {
  const [isSubmitted, setIsSubmitted] = useState(false)
  const onHide = () => {
    setIsModalOpen(false)
    setIsSubmitted(false)
  }
  useEffect(() => {
    isModalOpen
      ? (document.documentElement.style.overflowY = 'hidden')
      : (document.documentElement.style.overflowY = 'scroll')
  }, [isModalOpen])

  return (
    <>
      <div className={styles.isMobile}>
        <ModalMobile
          align="left"
          show={isModalOpen && !isSubmitted}
          onHide={() => onHide()}
          padding="30px"
          urlhash=""
          showOverlayBackground
          wrapperStyles={{ height: '75vh' }}
        >
          <div className={styles.modalContent}>
            <div className={styles.loader}>
              <img src={LOADER_GIF} alt='loader-gif'/>
            </div>
          <div
            dangerouslySetInnerHTML={{ __html: content }}
            style={{
              width: '110%',
              position: 'relative',
              left: '-20px',
              zIndex: '2',
              background: 'white',
            }}
          />
          </div>
        </ModalMobile>
      </div>
      <div className={styles.isDesktop}>
        <ModalDesktop
          align="left"
          show={isModalOpen && !isSubmitted}
          onHide={() => onHide()}
          padding="30px"
          urlhash=""
          showOverlayBackground
          styles={{ boxShadow: '1px 1px 2px 1px rgba(0,0,0,0.5)', height: '80vh', width: '720px' }}
        >
          <div className={styles.modalContent}>
            <div className={styles.loader}>
              <img src={LOADER_GIF} alt='loader-gif'/>
            </div>
            <div
              dangerouslySetInnerHTML={{ __html: content }}
              style={{
                zIndex: '2',
                background: 'white',
                position: 'relative'
              }}
            />
          </div>
        </ModalDesktop>
      </div>
    </>
  )
}

export default BusinessModals
